document.addEventListener('DOMContentLoaded', function(){

    const modal = document.getElementById('engravingModal');
    //const openBtn = document.getElementById('openEngravingPopup');
    const closeBtn = document.querySelector('.engraving-close');
    const cancelBtn = document.getElementById('cancelEngraving');

    const input = document.getElementById('engravingMessage');
    const counter = document.getElementById('engravingCount');

    const previewText = document.getElementById('ringPreviewText');
    const preview = document.getElementById('ringPreview');

    //const hiddenEngraving = document.getElementById('engravingProperty');
    //const hiddenFont = document.getElementById('engravingFontProperty');
    let selectedFont = 'roman';
    let activeProductForm = null;
    let activeProductId = null;
    let activeTrigger = null;

    const saveBtn = document.getElementById('saveEngraving');

    // document.addEventListener('click', function(e){

    //     const trigger = e.target.closest('.engraving-trigger');

    //     if(!trigger) return;

    //     activeProductForm = trigger.closest('form');

    //     if(!activeProductForm) return;

    //     activeProductId = activeProductForm.dataset.productId;

    //     modal.classList.add('active');
    //     $('body').addClass('engraving_model_open');

    // });

    // document.addEventListener('click', function(e){

    //     const trigger = e.target.closest('.engraving-trigger');
    //     if(!trigger) return;

    //     activeTrigger = trigger;

    //     // Product page / Sticky
    //     activeProductForm = trigger.closest('form');

    //     // Quick View
    //     if(!activeProductForm){

    //         const quickViewForm = document.querySelector('.quickview-product-form');

    //         if(quickViewForm){
    //             activeProductForm = quickViewForm;
    //         }
    //     }

    //     if(!activeProductForm){
    //         console.warn('Engraving form not found');
    //         return;
    //     }

    //     activeProductId = activeProductForm.dataset.productId;

    //     loadEngravingProperties();

    //     modal.classList.add('active');
    //     $('body').addClass('engraving_model_open');

    // });

    document.addEventListener('click', function(e){

        const trigger = e.target.closest('.engraving-trigger');

        if(!trigger) return;

        // Remember the exact trigger clicked
        activeTrigger = trigger;

        /*
        * ==========================================
        * 1. MAIN PRODUCT / STICKY FORM
        * ==========================================
        *
        * If trigger is inside a form, use that form.
        */
        activeProductForm = trigger.closest('form');


        /*
        * ==========================================
        * 2. QUICK VIEW
        * ==========================================
        *
        * In Quick View the engraving trigger is
        * outside the product form.
        *
        * This is your previous working logic,
        * so keep it.
        */
        if(!activeProductForm){

            const quickViewForm =
                trigger.closest('.productView-options')?.querySelector(
                    '.quickview-product-form'
                ) ||
                trigger.closest('.productView')?.querySelector(
                    '.quickview-product-form'
                ) ||
                document.querySelector(
                    '.quickview-product-form'
                );

            if(quickViewForm){

                activeProductForm = quickViewForm;

            }

        }


        /*
        * ==========================================
        * 3. FALLBACK USING DATA-PRODUCT-ID
        * ==========================================
        *
        * Useful because the trigger is now in
        * product-variant.liquid.
        */
        if(!activeProductForm && trigger.dataset.productId){

            activeProductForm =
                document.querySelector(
                    `form[data-product-id="${trigger.dataset.productId}"]`
                );

        }


        /*
        * ==========================================
        * 4. STOP IF FORM STILL NOT FOUND
        * ==========================================
        */
        if(!activeProductForm){

            console.warn(
                'Engraving: product form not found',
                trigger
            );

            return;

        }


        /*
        * ==========================================
        * 5. GET PRODUCT ID FROM THE ACTUAL FORM
        * ==========================================
        */
        activeProductId =
            activeProductForm.dataset.productId;


        /*
        * ==========================================
        * 6. LOAD CURRENT ENGRAVING
        * ==========================================
        */
        loadEngravingProperties();


        /*
        * ==========================================
        * 7. OPEN POPUP
        * ==========================================
        */
        modal.classList.add('active');

        $('body').addClass('engraving_model_open');

    });

    function loadEngravingProperties(){

        input.value = '';

        let engravingField = null;
        let fontField = null;
        let remarksField = null;

        if(activeProductForm){

            engravingField =
                activeProductForm.querySelector(
                    '[name="properties[Engraving]"]'
                );

            fontField =
                activeProductForm.querySelector(
                    '[name="properties[Engraving Font]"]'
                );

            remarksField =
                activeProductForm.querySelector(
                    '[name="properties[Customer Remarks]"]'
                );
        }

        if(engravingField){
            input.value = engravingField.value || '';
        }

        if(fontField){
            selectedFont = fontField.value || 'roman';
        }else{
            selectedFont = 'roman';
        }

        previewText.setAttribute(
            'data-font',
            selectedFont
        );

        document.querySelectorAll('.font-btn').forEach(function(btn){

            btn.classList.toggle(
                'active',
                btn.dataset.font === selectedFont
            );

        });

        const remarksPopup =
            document.getElementById('customer-remarks-popup');

        if(remarksPopup){

            remarksPopup.value =
                remarksField ? remarksField.value : '';

        }

        counter.textContent =
            15 - input.value.length;

        renderCurvedText(input.value);

        preview.classList.toggle(
            'zoom',
            input.value.trim() !== ''
        );

    }

    closeBtn.addEventListener('click', function(){
        modal.classList.remove('active');
        $('body').removeClass('engraving_model_open');
    });

    cancelBtn.addEventListener('click', function(){
        modal.classList.remove('active');
        $('body').removeClass('engraving_model_open');
    });

    const symbolMap = {};

    document.querySelectorAll('.engraving-icon').forEach(btn => {

        btn.style.backgroundPosition =
            `${btn.dataset.pos}px 0px`;

        //symbolMap[btn.dataset.symbol] = btn.dataset.pos;
        symbolMap[btn.dataset.symbol.normalize()] = btn.dataset.pos;

    });
    document.querySelectorAll('.engraving-icon').forEach(btn => {

        btn.addEventListener('click', function(){

            if(input.value.length >= 15){
                return;
            }

            input.value += this.dataset.symbol;
            //input.value += `{${this.dataset.index}}`;
            counter.textContent = 15 - input.value.length;

            renderCurvedText(input.value);
                if(input.value.trim() !== ''){
                    preview.classList.add('zoom');
                }else{
                    preview.classList.remove('zoom');
                }
        });

    });

    input.addEventListener('input', function(){

        const text = this.value;

        counter.textContent =
            15 - text.length;

        renderCurvedText(text);

        if(text.trim() !== ''){
            preview.classList.add('zoom');
        }else{
            preview.classList.remove('zoom');
        }

    });

    function renderCurvedText(text){

        previewText.innerHTML = '';

        if(!text) return;

        const chars = Array.from(text);

        const charSpacing = 12;

        const centerX = 125;
        const baseY = 100;

        chars.forEach((char,index)=>{

            const distance =
                index - ((chars.length - 1) / 2);

            const x =
                centerX +
                (distance * charSpacing);

            const y =
                baseY +
                (distance * distance * 0.12);

            const rotate =
                distance * 0.9;

            
            //const iconPos = symbolMap[char];
            const iconPos = symbolMap[char.normalize()];

            if(iconPos !== undefined){

                const icon =
                    document.createElement('span');

                icon.className = 'preview-symbol';

                icon.style.position = 'absolute';
                icon.style.width = '24px';
                icon.style.height = '24px';

                icon.style.backgroundImage =
                    "url('/cdn/shop/files/engraving-icons.webp')";

                icon.style.backgroundRepeat = 'no-repeat';

                icon.style.backgroundSize =
                    'auto 24px';

                icon.style.backgroundPosition =
                    `${iconPos}px 0px`;

                icon.style.left = '0';
                icon.style.top = '0';

                icon.style.transform =
                    `translate(${x}px, ${y}px)
                    translate(-50%,0)`;

                previewText.appendChild(icon);

            }else{

                const span =
                    document.createElement('span');

                span.textContent = char;

                span.className =
                    'engraving-char ' +
                    (previewText.getAttribute('data-font') || 'roman');

                span.style.position = 'absolute';

                span.style.left = '0';
                span.style.top = '0';

                span.style.transform =
                    `translate(${x}px, ${y}px)
                    rotate(${rotate}deg)
                    translate(-50%,0)`;

                previewText.appendChild(span);

            }

        });

    }

    input.addEventListener('input', function(){

        const text = this.value;

        counter.textContent = 15 - text.length;

        renderCurvedText(text);

        if(text.trim() !== ''){
            preview.classList.add('zoom');
        }else{
            preview.classList.remove('zoom');
        }

    });

    document.querySelectorAll('.font-btn').forEach(function(btn){

        btn.addEventListener('click', function(){

            document
                .querySelectorAll('.font-btn')
                .forEach(function(b){
                    b.classList.remove('active');
                });

            this.classList.add('active');

            const font = this.dataset.font;

            previewText.setAttribute('data-font', font);

            renderCurvedText(input.value);

            //hiddenFont.value = font;
            selectedFont = font;

        });

    });

    // function syncEngravingProperties(){

    //     if(!activeProductForm || !activeProductId) return;

    //     const engraving = input.value;
    //     const font = selectedFont;
    //     const remarks = document.getElementById('customer-remarks-popup').value;
    //     document.querySelectorAll(`form[data-product-id="${activeProductId}"]`).forEach(function(form){
    //         const engravingField = form.querySelector('[name="properties[Engraving]"]');
    //         const fontField = form.querySelector('[name="properties[Engraving Font]"]');
    //         const remarksField = form.querySelector('[name="properties[Customer Remarks]"]');
    //         if(engravingField){
    //             engravingField.value = engraving;
    //         }
    //         if(fontField){
    //             fontField.value = font;
    //         }
    //         if(remarksField){
    //             remarksField.value = remarks;
    //         }
    //     });

    // }

    function syncEngravingProperties(){
        if(!activeProductForm || !activeProductId) return;
        const engraving = input.value.trim();
        document.querySelectorAll(`form[data-product-id="${activeProductId}"]`).forEach(function(form){
            const engravingField = form.querySelector('[name="properties[Engraving]"]');
            const fontField = form.querySelector('[name="properties[Engraving Font]"]');
            const remarksField = form.querySelector('[name="properties[Customer Remarks]"]');
            if (!engraving) {
                // no engraving entered — disable the fields so they aren't submitted at all
                if (engravingField) engravingField.disabled = true;
                if (fontField) fontField.disabled = true;
            } else {
                if (engravingField) { engravingField.disabled = false; engravingField.value = engraving; }
                if (fontField) { fontField.disabled = false; fontField.value = selectedFont; }
            }
            if (remarksField) remarksField.value = document.getElementById('customer-remarks-popup').value;
        });
    }


    
    function loadEngravingProperties() {

        input.value = '';

        const engravingField = activeProductForm.querySelector('[name="properties[Engraving]"]');
        const fontField = activeProductForm.querySelector('[name="properties[Engraving Font]"]');
        const remarksField = activeProductForm.querySelector('[name="properties[Customer Remarks]"]');

        if (engravingField) {
            input.value = engravingField.value || '';
        }

        if (fontField) {
            selectedFont = fontField.value || 'roman';
        } else {
            selectedFont = 'roman';
        }

        previewText.setAttribute('data-font', selectedFont);

        document.querySelectorAll('.font-btn').forEach(btn => {
            btn.classList.toggle(
                'active',
                btn.dataset.font === selectedFont
            );
        });

        const remarksPopup = document.getElementById('customer-remarks-popup');

        if (remarksPopup) {
            remarksPopup.value = remarksField ? remarksField.value : '';
        }

        counter.textContent = 15 - input.value.length;

        renderCurvedText(input.value);

        preview.classList.toggle(
            'zoom',
            input.value.trim() !== ''
        );
    }


    saveBtn.addEventListener('click', function(){

        //hiddenEngraving.value = input.value;
        //document.getElementById('customer-remarks-hidden').value = document.getElementById('customer-remarks-popup').value;
        syncEngravingProperties();
        modal.classList.remove('active');
        // if (activeProductForm) {

        //     const trigger =
        //         activeProductForm.querySelector('.engraving-trigger');

        //     if (trigger) {

        //         const label = trigger.querySelector('.eng_label');

        //         if (label) {

        //             const step =
        //                 label.textContent.trim().startsWith('4.')
        //                     ? '4'
        //                     : '3';

        //             label.innerHTML =
        //                 `${step}. Engraving: <span>${input.value || 'None'}</span>`;
        //         }
        //     }
        // }

        if (activeTrigger) {
            const label = activeTrigger.querySelector('.eng_label');
            if (label) {
                const step =
                    label.textContent.trim().startsWith('4.')
                        ? '4'
                        : '3';

                label.innerHTML = `${step}. Engraving: <span>${input.value || 'None'}</span>`;
            }
        }


    });

    const modalContent = document.querySelector('.engraving-modal-content');
    const grid = document.querySelector('.engraving-grid');

    if (window.visualViewport) {

        visualViewport.addEventListener('resize', function () {

            if (window.innerWidth > 768) return;

            document.querySelector('.engraving-grid').scrollTo({top: -250});

            const keyboard = window.innerHeight - visualViewport.height;

            if (keyboard > 150) {
                setTimeout(function() {
                    modalContent.style.transform = `translate(-50%, calc(-50% + ${keyboard / 2}px))`;
                }, 100);
                

            } else {

                modalContent.style.transform = 'translate(-50%, -50%)';

            }

        });

    }
    


});